"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FormFieldFromProps_1 = __importDefault(require("@Fields/v2/FormFieldFromProps"));
const react_hook_form_1 = require("react-hook-form");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const RegistrationPopup_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RegistrationPopup"));
const MemberDetailsSection = (props) => {
    const { watch, setValue } = (0, react_hook_form_1.useFormContext)();
    const { memberType, memberSubType, name } = props;
    const [popupIsOpen, setPopupIsOpen] = (0, react_1.useState)(false);
    const [isCMOorPublisher, setIsCMOorPublisher] = (0, react_1.useState)(false);
    const [notEligible, setNotEligible] = (0, react_1.useState)(false);
    const memberTypeValue = watch('memberType');
    const memberSubTypeValue = watch('memberSubType');
    const closePopup = () => {
        setValue('memberSubType', '');
        setPopupIsOpen(false);
    };
    const determineIsCMOorPublisher = () => {
        const isCMOorPublisherLocal = memberTypeValue === 'CMO' || memberTypeValue === 'Publisher';
        setIsCMOorPublisher(isCMOorPublisherLocal);
        if (isCMOorPublisherLocal) {
            setValue('memberSubType', 'Self Administered');
        }
        return isCMOorPublisherLocal;
    };
    const determineNotEligible = (isCMOorPublisherLocal) => {
        const notEligibleLocal = !isCMOorPublisherLocal && memberSubTypeValue === 'Fully Administered';
        setNotEligible(notEligibleLocal);
        if (notEligibleLocal) {
            setPopupIsOpen(true);
        }
    };
    const determineIdontKnow = () => {
        if (memberSubTypeValue === "I don't know") {
            setNotEligible(false);
            setPopupIsOpen(true);
        }
    };
    (0, react_1.useEffect)(() => {
        const isCMOorPublisherLocal = determineIsCMOorPublisher();
        determineNotEligible(isCMOorPublisherLocal);
        determineIdontKnow();
    }, [memberSubTypeValue, memberTypeValue]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "member-setails-section" },
            memberType && react_1.default.createElement(FormFieldFromProps_1.default, { field: memberType }),
            !isCMOorPublisher && react_1.default.createElement(FormFieldFromProps_1.default, { field: memberSubType }),
            react_1.default.createElement(FormFieldFromProps_1.default, { field: name })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: popupIsOpen },
            react_1.default.createElement(RegistrationPopup_1.default, { closePopup: closePopup, notEligible: notEligible }))));
};
exports.default = MemberDetailsSection;
